import * as constants from "./constants";

export default function(state, action){
    if (!state || action.type == constants.OPERATOR_PHONE_CLEAR_STORE){
        state = {
            data: {},
            isLoading: false,
            isSave: false,
            isLoaded: false
        };
    }

    switch(action.type){
        case constants.OPERATOR_PHONE_NEW_SAVE_START:
            return {...state, ...{isLoading: true, error: undefined}};
        case constants.OPERATOR_PHONE_NEW_SAVE_SUCCESS:
            return { ...state, ...{data: action.data, isLoading: false, isSave: true}};
        case constants.OPERATOR_PHONE_NEW_SAVE_FAIL:
            return {...state, ...{isLoading: false, error: action.error}};

        case constants.OPERATOR_PHONE_SAVE_START:
            return {...state, ...{isLoading: true, error: undefined}};
        case constants.OPERATOR_PHONE_SAVE_SUCCESS:
            return { ...state, ...{data: action.data, isLoading: false, isSave: true}};
        case constants.OPERATOR_PHONE_SAVE_FAIL:
            return {...state, ...{isLoading: false, error: action.error}};

        case constants.OPERATOR_PHONE_DETAIL_START:
            return {...state, ...{isLoading: true, error: undefined}};
        case constants.OPERATOR_PHONE_DETAIL_SUCCESS:
            return { ...state, ...{data: action.data, isLoading: false, isLoaded: true}};
        case constants.OPERATOR_PHONE_DETAIL_FAIL:
            return {...state, ...{isLoading: false, error: action.error}};

        default:
            return state;
    }
}
